import { bindingMode } from "aurelia-binding";
import { bindable } from "aurelia-templating";
import { autoinject } from "aurelia-dependency-injection";

import { HopeCenterService } from "../../../../../services/hope-center-service";
import { IHopeSignaturesResponse } from "../../../../../interfaces/i-hope-center";

@autoinject
export class HopeSignatures {
    @bindable({ defaultBindingMode: bindingMode.toView })
    public exportId: string = "";
    @bindable({ defaultBindingMode: bindingMode.toView })
    public hasViewPermission: boolean;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public hasEditPermission: boolean;
    private _hopeCenterService: HopeCenterService;
    public columns: number = 4;
    public isLoading: boolean = false;
    public isError: boolean = false;
    public signatures: IHopeSignaturesResponse;

    public constructor(hopeCenterService: HopeCenterService) {
        this._hopeCenterService = hopeCenterService;
    }

    public async attached() {
        await this.getSignatures();
    }

    public async getSignatures() {
        try {
            this.isError = false;
            this.isLoading = true;
            this.signatures = await this._hopeCenterService.getSectionZSignatures(this.exportId);
        } catch (e) {
            this.isError = true;
        } finally {
            this.isLoading = false;
        }
    }
}
